import { useState } from "react";
import VideoModal from "./VideoModal";

export default function VideoSection() {
  const [videoId, setVideoId] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const openOverlay = (id) => {
    setVideoId(id);
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeOverlay = () => {
    setIsOpen(false);
    setVideoId(null);
    document.body.style.overflow = "auto";
  };

  return (
    <>
      <div className="container">
        <div className="row position-relative align-items-start">
          <div className="col-12 col-lg-6 p-0">
            <div
              className="video-thumb"
              onClick={() => openOverlay("40YryQ_fCuk")}
            >
              <img
                className="img-60 bg-rounded-top"
                src="../img/photo-videothumb.webp"
                alt="San Diego, CA"
              />
              <div className="play-btn img-60-offset">
                <i className="fas fa-play" aria-hidden="true"></i>
              </div>
            </div>
          </div>

          {/* Text Content Section */}
          <div className="col-12 col-lg-6 p-5 bg-red-purple bg-rounded mt-lg-5 position-relative bg-rounded">
            <p className="color-white mb-xxl-3 mb-5">
              Created by BalancedComp, this event brings together{" "}
              <strong>industry experts</strong>,{" "}
              <strong>leading-edge data</strong>, and{" "}
              <strong>networking opportunities</strong> with{" "}
              <strong>like-minded professionals</strong> seeking to optimize and
              elevate their organization's{" "}
              <span className="nobr">compensation strategy</span>.
            </p>

            <div className="row align-items-center">
              <div className="col flex-grow-1">
                <div className="cert-logo-container">
                  <img
                    src="../img/logo-certs2.webp"
                    alt="Approved for Certifications"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <VideoModal isOpen={isOpen} videoId={videoId} onClose={closeOverlay} />
    </>
  );
}
